
import React, { useState, useEffect } from 'react';
import { Link } from "react-scroll";
import './tempnav.css';
import { FaBars, FaTimes, FaShoppingCart } from 'react-icons/fa';
import { RiFridgeLine } from 'react-icons/ri';
import { GiAutoRepair } from 'react-icons/gi';
import { AiTwotonePhone } from 'react-icons/ai';

function Navbar() {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const showButton = () => {
    if (window.innerWidth <= 160) {
      setButton(false);
    } else {
      setButton(true);
    }
  };
  

  return (
    <>    
              <nav className='navbar'>
          <div className='navbar-container container'>
            
            <a href='/' className='navbar-logo' onClick={closeMobileMenu}>
            <img id='logo' src="/assets/Yuksel Hair Concept Berber.png" alt="" />
            </a>
            <div className='menu-icon' onClick={handleClick}>
              {click ? <FaTimes /> : <FaBars />}
            </div>
           
          
           
            <ul className={click ? 'nav-menu active' : 'nav-menu'}>

            <li className='nav-item nav-1'>
                 <a href="/"  className='nav-links' onClick={closeMobileMenu}>
                   ANASAYFA
                 </a>
               </li>

            <li id="kellog" className='nav-item'>
                 <a href="/" id='bruhh' onClick={closeMobileMenu} className='nav-links nav-1' >
                  HİZMETLERİMİZ
                   </a>
                 </li>
                 <li className='nav-item'>
                 <a href='/' className='nav-links nav-1' onClick={closeMobileMenu}>
                  FİYAT LİSTESİ
                 </a>
               </li>
               
               <li className='nav-item'>
                 <a href='/' className='nav-links nav-1' onClick={closeMobileMenu}>
                    İLETİŞİM
                 </a>
               </li> 
               </ul>
                <a id='obamna' href="tel:+90 531 287 20 81">RANDEVU AL</a>
          </div>
        </nav>
    </>
  );
}

export default Navbar;


